import '../css/HomePage.css'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import Silk from './Silk';
import blocboxlogobg from '../images/output-onlinetools.png';
import InfiniteMenu from './InfiniteMenu'
import Navbar from './Navbar';
import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const HomePage = () => {
  const navigate = useNavigate()

  // Banner state
  const [bannerData, setBannerData] = useState(null);
  const [bannerLoading, setBannerLoading] = useState(true);

//new comment changes needed
// Fetch banner data
useEffect(() => {
  const fetchBannerData = async () => {
    try {
      const { data, error } = await supabase
        .from('banner_settings')
        .select('*')
        .single();

      if (error) throw error;
      setBannerData(data);
    } catch (error) {
      console.error('Error fetching banner:', error);
    } finally {
      setBannerLoading(false);
    }
  };

  fetchBannerData();

  // Subscribe to real-time changes
  const subscription = supabase
    .channel('banner_changes')
    .on('postgres_changes', 
      { event: 'UPDATE', schema: 'public', table: 'banner_settings' },
      (payload) => {
        setBannerData(payload.new);
      }
    )
    .subscribe();

  return () => {
    subscription.unsubscribe();
  };
}, []);

  const items = [
    {
      image: `data:image/svg+xml,${encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="300" height="300">
          <defs>
            <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#667eea;stop-opacity:1" />
              <stop offset="100%" style="stop-color:#764ba2;stop-opacity:1" />
            </linearGradient>
          </defs>
          <rect width="300" height="300" fill="url(#grad1)" />
          <text x="150" y="130" text-anchor="middle" fill="white" font-size="20" font-family="Arial">
            <tspan x="150" dy="0">Cheapest consumer</tspan>
            <tspan x="150" dy="25">cross border</tspan>
            <tspan x="150" dy="25">delivery</tspan>
          </text>
        </svg>
      `)}`,
      link: 'https://useblocbox.com/',
      title: 'Item 1',
      description: 'This is pretty cool, right?'
    },
    {
      image: `data:image/svg+xml,${encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="300" height="300">
          <defs>
            <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#f093fb;stop-opacity:1" />
              <stop offset="100%" style="stop-color:#f5576c;stop-opacity:1" />
            </linearGradient>
          </defs>
          <rect width="300" height="300" fill="url(#grad2)" />
          <text x="150" y="140" text-anchor="middle" fill="white" font-size="20" font-family="Arial">
            <tspan x="150" dy="0">24/7 access to</tspan>
            <tspan x="150" dy="25">rental lockers</tspan>
          </text>
        </svg>
      `)}`,
      link: 'https://useblocbox.com/',
      title: 'Item 2',
      description: 'This is pretty cool, right?'
    },
    {
      image: `data:image/svg+xml,${encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="300" height="300">
          <defs>
            <linearGradient id="grad3" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#4facfe;stop-opacity:1" />
              <stop offset="100%" style="stop-color:#00f2fe;stop-opacity:1" />
            </linearGradient>
          </defs>
          <rect width="300" height="300" fill="url(#grad3)" />
          <text x="150" y="140" text-anchor="middle" fill="white" font-size="20" font-family="Arial">
            <tspan x="150" dy="0">Fuss-free online</tspan>
            <tspan x="150" dy="25">shopping in malaysia</tspan>
          </text>
        </svg>
      `)}`,
      link: 'https://useblocbox.com/',
      title: 'Item 3',
      description: 'This is pretty cool, right?'
    },
    {
      image: `data:image/svg+xml,${encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="300" height="300">
          <defs>
            <linearGradient id="grad4" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#43e97b;stop-opacity:1" />
              <stop offset="100%" style="stop-color:#38f9d7;stop-opacity:1" />
            </linearGradient>
          </defs>
          <rect width="300" height="300" fill="url(#grad4)" />
          <text x="150" y="140" text-anchor="middle" fill="white" font-size="20" font-family="Arial">
            <tspan x="150" dy="0">Singaporean-owned</tspan>
            <tspan x="150" dy="25">business, trust us lah</tspan>
          </text>
        </svg>
      `)}`,
      link: 'https://useblocbox.com/',
      title: 'Item 4',
      description: 'This is pretty cool, right?'
    },
    {
      image: `data:image/svg+xml,${encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="300" height="300">
          <defs>
            <linearGradient id="grad5" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#fa709a;stop-opacity:1" />
              <stop offset="100%" style="stop-color:#fee140;stop-opacity:1" />
            </linearGradient>
          </defs>
          <rect width="300" height="300" fill="url(#grad5)" />
          <text x="150" y="130" text-anchor="middle" fill="white" font-size="20" font-family="Arial">
            <tspan x="150" dy="0">Safe and secure</tspan>
            <tspan x="150" dy="25">space for your</tspan>
            <tspan x="150" dy="25">precious items</tspan>
          </text>
        </svg>
      `)}`,
      link: 'https://useblocbox.com/',
      title: 'Item 5',
      description: 'This is pretty cool, right?'
    },
    {
      image: `data:image/svg+xml,${encodeURIComponent(`
        <svg xmlns="http://www.w3.org/2000/svg" width="300" height="300">
          <defs>
            <linearGradient id="grad6" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#a8edea;stop-opacity:1" />
              <stop offset="100%" style="stop-color:#fed6e3;stop-opacity:1" />
            </linearGradient>
          </defs>
          <rect width="300" height="300" fill="url(#grad6)" />
          <text x="150" y="130" text-anchor="middle" fill="black" font-size="20" font-family="Arial">
            <tspan x="150" dy="0">Buy in ringgit,</tspan>
            <tspan x="150" dy="25">save in singapore</tspan>
            <tspan x="150" dy="25">dollars</tspan>
          </text>
        </svg>
      `)}`,
      link: 'https://useblocbox.com/',
      title: 'Item 6',
      description: 'This is pretty cool, right?'
    }
  ];

  return (
    <>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>BlocBox - Cross-Border Delivery</title>
      <link
        href="https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700;900&family=Rajdhani:wght@300;400;500;600;700&display=swap"
        rel="stylesheet"
      />
      <style
        dangerouslySetInnerHTML={{
          __html: `
            * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
            }

            :root {
                --primary-cyan: #00ffff;
                --primary-purple: #8b00ff;
                --primary-pink: #ff0080;
                --dark-bg: #0a0a0a;
                --darker-bg: #050505;
                --accent-blue: #0066ff;
                --neon-green: #39ff14;
                --text-light: #e0e0e0;
                --text-dim: #888;
                --new-color:#ebebeb;
            }

            body {
                font-family: 'Rajdhani', sans-serif;
                background: var(--dark-bg);
                color: var(--text-light);
                line-height: 1.6;
                overflow-x: hidden;
            }

            /* Animated Background */
            .bg-animation {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: -1;
                background: linear-gradient(45deg, #0a0a0a, #1a0033, #000d1a, #0a0a0a);
                background-size: 400% 400%;
                animation: gradientShift 15s ease infinite;
            }

            .bg-animation::before {
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                background-image: 
                    radial-gradient(circle at 20% 80%, rgba(0, 255, 255, 0.1) 0%, transparent 50%),
                    radial-gradient(circle at 80% 20%, rgba(255, 0, 128, 0.1) 0%, transparent 50%),
                    radial-gradient(circle at 40% 40%, rgba(139, 0, 255, 0.1) 0%, transparent 50%);
                animation: float 20s ease-in-out infinite;
            }

          /* Disclaimer Section */
.disclaimer-section {
  padding: 80px 20px;
  background: linear-gradient(135deg, rgba(0, 255, 255, 0.02), rgba(139, 0, 255, 0.02));
  position: relative;
  overflow: hidden;
}

/* Admin Banner Section */
.admin-banner-section {
  padding: 0;
  border-top: 2px solid rgba(16, 185, 129, 0.3);
  border-bottom: 2px solid rgba(16, 185, 129, 0.3);
  position: relative;
  overflow: hidden;
}

.admin-banner-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(16, 185, 129, 0.15), transparent);
  animation: bannerShimmer 4s ease-in-out infinite;
  z-index: 1;
  pointer-events: none;
}

@keyframes bannerShimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.admin-banner-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 154px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 100px;
}

/* Background image - covers entire banner */
.admin-banner-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.25;
  z-index: 1;
}

.admin-banner-text {
  font-size: 17px;
  font-weight: 700;
  color: #e0e0e0;
  text-align: center;
  line-height: 1.6;
  letter-spacing: 0.3px;
  position: relative;
  z-index: 3;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
  max-width: 90%;
}

/* Responsive Design */
@media (max-width: 768px) {
  .admin-banner-container {
    padding: 150px 20px;
    min-height: 80px;
  }

  .admin-banner-text {
    font-size: 14px;
  }
}
  


.disclaimer-container {
  max-width: 1400px;
  Yorkshire: 0px;
  margin: 0 auto;
  text-align: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, rgba(0, 255, 255, 0.1), rgba(139, 0, 255, 0.1));
  border: 2px solid rgba(0, 255, 255, 0.3);
  border-radius: 20px;
  backdrop-filter: blur(20px);
  position: relative;
  z-index: 2;
  pointer-events: auto; /* Ensure container allows pointer events */
}

.disclaimer-container::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(0, 255, 255, 0.1) 0%, transparent 70%);
  animation: rotate 10s linear infinite;
  pointer-events: none; /* Prevent pseudo-element from blocking clicks */
  z-index: 1; /* Place below content */
}

.disclaimer-text {
  font-size: 22px;
  color: var(--text-light);
  line-height: 1.5;
  margin-bottom: 20px;
  position: relative;
  z-index: 3; /* Ensure text is above background elements */
  pointer-events: auto; /* Ensure text allows pointer events */
}

.disclaimer-link {
  color: var(--primary-cyan);
  font-weight: 700;
  text-decoration: none;
  margin: 0 5px;
  transition: color 0.3s ease, text-shadow 0.3s ease;
  cursor: pointer; /* Explicitly set pointer cursor */
  pointer-events: auto; /* Ensure links are clickable */
  z-index: 4; /* Ensure links are above all other elements */
}

.disclaimer-link:hover {
  color: var(--primary-pink);
  text-shadow: 0 0 10px rgba(255, 0, 128, 0.5);
}

/* Animation for background effect */
@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 768px) {
  .disclaimer-section {
    padding: 60px 15px;
  }

  .disclaimer-container {
    padding: 30px 15px;
  }

  .disclaimer-text {
    font-size: 16px;
  }
}

            @keyframes gradientShift {
                0%, 100% { background-position: 0% 50%; }
                50% { background-position: 100% 50%; }
            }

            @keyframes float {
                0%, 100% { transform: translateY(0px) rotate(0deg); }
                33% { transform: translateY(-20px) rotate(2deg); }
                66% { transform: translateY(10px) rotate(-1deg); }
            }

       

  .background-silk-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 0; /* background layer */
  pointer-events: none; /* let user interact with stuff on top */
  overflow: hidden;
}

.background-silk {
  width: 100%;
  height: 100%;
}

            /* Hero Section */
            .hero {
                min-height: 100vh;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                padding-top: 80px;
                overflow: hidden;
            }

            .hero-container {
                max-width: 1400px;
                margin: 0 auto;
                padding: 0 20px;
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 50px;
                align-items: center;
                position: relative;
                z-index: 2;
            }

            .hero-content {
                z-index: 2;
            }

            .hero-title {
                font-family: 'Orbitron', monospace;
                font-size: clamp(2.5rem, 6vw, 4rem);
                font-weight: 900;
                line-height: 1.1;
                margin-bottom: 20px;
                background: linear-gradient(45deg, #39ff14, #f5f90a, #ff6ec7);

                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                animation: titleGlow 3s ease-in-out infinite alternate;
            }

            @keyframes titleGlow {
                from { filter: drop-shadow(0 0 20px rgba(0, 255, 255, 0.3)); }
                to { filter: drop-shadow(0 0 40px rgba(139, 0, 255, 0.5)); }
            }

            .hero-subtitle {
                font-size: clamp(16px, 2.5vw, 18px);
                margin-bottom: 30px;
                color: #e3e3e3;
                font-weight: 400;
            }

            .hero-highlight {
                color: var(--primary-cyan);
                font-weight: 700;
                text-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
            }

            .cta-button {
                display: inline-block;
                padding: 15px 30px;
                background: linear-gradient(45deg, var(--primary-cyan), var(--primary-purple));
                border: none;
                border-radius: 50px;
                color: white;
                font-family: 'Orbitron', monospace;
                font-size: 16px;
                font-weight: 700;
                text-decoration: none;
                cursor: pointer;
                transition: all 0.3s ease;
                position: relative;
                overflow: hidden;
                box-shadow: 0 10px 30px rgba(0, 255, 255, 0.3);
            }

            .cta-button::before {
                content: '';
                position: absolute;
                top: 0;
                left: -100%;
                width: 100%;
                height: 100%;
                background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
                transition: left 0.5s ease;
            }

            .cta-button:hover::before {
                left: 100%;
            }

            .cta-button:hover {
                transform: translateY(-3px);
                box-shadow: 0 15px 40px rgba(0, 255, 255, 0.5);
            }

            .hero-visual {
                position: relative;
                height: 400px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .floating-box {
                width: 200px;
                height: 200px;
                background: linear-gradient(45deg, rgba(0, 255, 255, 0.1), rgba(139, 0, 255, 0.1));
                border: 2px solid var(--primary-cyan);
                border-radius: 20px;
                position: relative;
                animation: floatBox 6s ease-in-out infinite;
                box-shadow: 
                    0 0 50px rgba(0, 255, 255, 0.3),
                    inset 0 0 50px rgba(139, 0, 255, 0.1);
            }

.floating-box::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px; /* Adjust size as needed */
    height: 80px; /* Adjust size as needed */
    background-image: url(${blocboxlogobg}); /* Adjust path based on your project structure */
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    animation: pulse 2s ease-in-out infinite;
}

            @keyframes floatBox {
                0%, 100% { transform: translateY(0px) rotateY(0deg); }
                50% { transform: translateY(-30px) rotateY(10deg); }
            }

            @keyframes pulse {
                0%, 100% { transform: translate(-50%, -50%) scale(1); }
                50% { transform: translate(-50%, -50%) scale(1.1); }
            }

            /* Marquee */
            .marquee-section {
                padding: 20px 0;
                border-top: 1px solid rgba(0, 255, 255, 0.3);
                border-bottom: 1px solid rgba(0, 255, 255, 0.3);
                background: rgba(0, 255, 255, 0.05);
                overflow: hidden;
            }

.marquee {
    display: flex;
    animation: scroll 20s linear infinite;
    white-space: nowrap;
    width: 200%; /* Double the width to accommodate duplicated content */
}

@keyframes scroll {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); } /* Move only half the width for seamless looping */
}
            .marquee-item {
                flex-shrink: 0;
                padding: 0 40px;
                font-size: 16px;
                font-weight: 600;
                color: var(--primary-cyan);
                text-transform: uppercase;
                letter-spacing: 1px;
            }

          

            /* Reviews Section */
            .reviews-section {
                padding: 80px 20px;
                position: relative;
            }

            .section-title {
                font-family: 'Orbitron', monospace;
                font-size: clamp(2rem, 5vw, 3rem);
                font-weight: 900;
                text-align: center;
                margin-bottom: 60px;
                background: linear-gradient(45deg, var(--primary-cyan), var(--primary-purple));
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            .section-title::after {
                content: '';
                display: block;
                width: 80px;
                height: 3px;
                background: linear-gradient(90deg, var(--primary-cyan), var(--primary-purple));
                margin: 15px auto;
            }

            .reviews-container {
                display: flex;
                gap: 20px;
                overflow-x: auto;
                padding: 20px 0;
                scroll-behavior: smooth;
            }

            .review-card {
                min-width: 280px;
                padding: 30px;
                background: linear-gradient(135deg, rgba(0, 255, 255, 0.1), rgba(139, 0, 255, 0.1));
                border: 1px solid rgba(0, 255, 255, 0.3);
                border-radius: 20px;
                backdrop-filter: blur(20px);
                transition: all 0.3s ease;
                position: relative;
                overflow: hidden;
            }

            .review-card::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 2px;
                background: linear-gradient(90deg, var(--primary-cyan), var(--primary-purple), var(--primary-pink));
            }

            .review-card:hover {
                transform: translateY(-10px);
                box-shadow: 0 20px 50px rgba(0, 255, 255, 0.2);
            }

            .stars {
                color: var(--neon-green);
                font-size: 18px;
                margin-bottom: 15px;
            }

            .review-text {
                font-size: 14px;
                line-height: 1.5;
                margin-bottom: 15px;
                color: var(--text-light);
            }

            .reviewer-name {
                font-weight: 700;
                color: var(--primary-cyan);
                font-size: 12px;
                text-transform: uppercase;
                letter-spacing: 1px;
            }

            /* How It Works Section */
            .how-it-works {
                padding: 80px 20px;
                position: relative;
                background: linear-gradient(180deg, transparent, rgba(139, 0, 255, 0.05), transparent);
            }

            .steps-container {
                max-width: 1400px;
                margin: 0 auto;
                display: grid;
                grid-template-columns: 1fr;
                gap: 40px;
            }

            .step-card {
                padding: 40px 20px;
                text-align: center;
                position: relative;
                background: linear-gradient(135deg, rgba(0, 255, 255, 0.05), rgba(139, 0, 255, 0.05));
                border: 1px solid rgba(0, 255, 255, 0.2);
                border-radius: 20px;
                backdrop-filter: blur(20px);
                transition: all 0.5s ease;
                overflow: hidden;
            }

            .step-card::before {
                content: '';
                position: absolute;
                top: -50%;
                left: -50%;
                width: 200%;
                height: 200%;
                background: linear-gradient(45deg, transparent, rgba(0, 255, 255, 0.1), transparent);
                transform: rotate(45deg);
                transition: all 0.5s ease;
                opacity: 0;
            }

            .step-card:hover::before {
                opacity: 1;
                animation: shimmer 1.5s ease-in-out;
            }

            @keyframes shimmer {
                0% { transform: rotate(45deg) translateX(-100%); }
                100% { transform: rotate(45deg) translateX(100%); }
            }

            .step-card:hover {
                transform: translateY(-10px) scale(1.02);
                box-shadow: 0 20px 50px rgba(0, 255, 255, 0.3);
            }

            .step-number {
                font-family: 'Orbitron', monospace;
                font-size: 60px;
                font-weight: 900;
                background: linear-gradient(45deg, var(--primary-cyan), var(--primary-purple));
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                margin-bottom: 20px;
                display: block;
            }

            .step-title {
                font-family: 'Orbitron', monospace;
                font-size: 20px;
                font-weight: 700;
                margin-bottom: 15px;
                color: var(--text-light);
            }

            .step-description {
                font-size: 16px;
                line-height: 1.5;
                color: #e3e3e3;
            }

            /* Locker Sizes Section */
            .locker-sizes {
            
                padding: 250px 20px;
                background: linear-gradient(135deg, rgba(0, 255, 255, 0.02), rgba(255, 0, 128, 0.02));
               
            }

            .lockers-grid {
                max-width: 1400px;
                margin: 0 auto;
                display: grid;
                grid-template-columns: 1fr;
                gap: 30px;
                margin-top: 40px;
            }

            .locker-card {
                padding: 60px 20px;
                text-align: center;
                background: linear-gradient(135deg, rgba(0, 255, 255, 0.1), rgba(139, 0, 255, 0.1));
                border: 2px solid transparent;
                border-radius: 20px;
                backdrop-filter: blur(20px);
                transition: all 0.4s ease;
                position: relative;
                overflow: hidden;
            }

            .locker-card::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: linear-gradient(45deg, var(--primary-cyan), var(--primary-purple), var(--primary-pink), var(--primary-cyan));
                background-size: 400% 400%;
                animation: gradientBorder 8s ease infinite;
                z-index: -1;
                border-radius: 20px;
            }

            .locker-card::after {
                content: '';
                position: absolute;
                top: 2px;
                left: 2px;
                right: 2px;
                bottom: 2px;
                background: linear-gradient(135deg, rgba(10, 10, 10, 0.9), rgba(20, 20, 20, 0.9));
                border-radius: 18px;
                z-index: -1;
            }

            @keyframes gradientBorder {
                0%, 100% { background-position: 0% 50%; }
                50% { background-position: 100% 50%; }
            }

            .locker-card:hover {
                transform: translateY(-10px) rotateY(5deg);
                box-shadow: 0 20px 50px rgba(0, 255, 255, 0.3);
            }

            .locker-icon {
                font-size: 60px;
                margin-bottom: 20px;
                display: block;
                filter: drop-shadow(0 0 20px rgba(0, 255, 255, 0.5));
            }

            .locker-name {
                font-family: 'Orbitron', monospace;
                font-size: 30px;
                font-weight: 700;
                margin-bottom: 10px;
                color: var(--primary-cyan);
            }

            .locker-description {
                font-size: 18px;
                color: #e3e3e3;
                line-height: 1.5;
            }

            /* Pricing Section */
            .pricing-section {
                background: linear-gradient(180deg, rgba(139, 0, 255, 0.05), rgba(0, 255, 255, 0.05));
                padding: 80px 20px;
                margin-top: 250px;
            }

            .pricing-container {
                max-width: 600px;
                margin: 0 auto;
                text-align: center;
                padding: 60px 20px;
                background: linear-gradient(135deg, rgba(0, 255, 255, 0.1), rgba(139, 0, 255, 0.1));
                border: 2px solid rgba(0, 255, 255, 0.3);
                border-radius: 30px;
                backdrop-filter: blur(30px);
                position: relative;
                overflow: hidden;
            }

            .pricing-container::before {
                content: '';
                position: absolute;
                top: -50%;
                left: -50%;
                width: 200%;
                height: 200%;
                background: radial-gradient(circle, rgba(0, 255, 255, 0.1) 0%, transparent 70%);
                animation: rotate 10s linear infinite;
            }

            @keyframes rotate {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }

            .pricing-content {
                position: relative;
                z-index: 2;
            }

            .pricing-title {
                font-family: 'Orbitron', monospace;
                font-size: 28px;
                font-weight: 900;
                margin-bottom: 20px;
                color: var(--text-light);
            }

            .pricing-features {
                list-style: none;
                margin-bottom: 30px;
            }

            .pricing-features li {
                padding: 10px 0;
                font-size: 16px;
                color: #e3e3e3;
                position: relative;
            }

            .pricing-features li::before {
                content: '✓';
                color: var(--neon-green);
                font-weight: bold;
                margin-right: 10px;
                font-size: 18px;
            }

            .price-display {
                font-family: 'Orbitron', monospace;
                font-size: 36px;
                font-weight: 900;
                background: linear-gradient(45deg, var(--primary-cyan), var(--primary-purple));
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                margin-bottom: 20px;
            }

            .price-note {
                font-size: 16px;
                color: #e3e3e3;
                margin-bottom: 30px;
            }

            /* App Section */
            .app-section {
                padding: 80px 20px;
                background: linear-gradient(135deg, rgba(255, 0, 128, 0.05), rgba(139, 0, 255, 0.05));
            }

            .app-container {
                max-width: 1400px;
                margin: 0 auto;
                display: grid;
                grid-template-columns: 1fr;
                gap: 40px;
                align-items: center;
                text-align: center;
            }

            .app-content h2 {
                font-family: 'Orbitron', monospace;
                font-size: 32px;
                font-weight: 900;
                margin-bottom: 20px;
                background: linear-gradient(45deg, var(--primary-pink), var(--primary-purple));
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
            }

            .app-content p {
                font-size: 16px;
                line-height: 1.5;
                margin-bottom: 30px;
                color: var(--text-dim);
            }

 


            @keyframes phoneFloat {
                0%, 100% { transform: translateY(0px) rotate(0deg); }
                50% { transform: translateY(-20px) rotate(2deg); }
            }

            /* Sticky Cards Section */
            .features-section {
                margin-top: 80px;
            }

            .sticky-cards {
                display: flex;
                flex-direction: column;
                gap: 50vh;
                padding-bottom: 50vh;
            }

            .feature-card {
                position: sticky;
                top: 0;
                height: 100vh;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 60px 20px;
                color: white;
                text-align: center;
            }

            .feature-card:nth-child(1) {
                background: linear-gradient(135deg, #2B1BFF, #0D2050);
            }

            .feature-card:nth-child(2) {
                background: linear-gradient(135deg, #5D2B36, #BDA6A3);
            }

            .feature-card:nth-child(3) {
                background: linear-gradient(135deg, #9FCA85, #549741);
            }

            .feature-card:nth-child(4) {
                background: linear-gradient(135deg, #0B0F27, #180179);
            }

            .feature-content {
                max-width: 600px;
            }

            .feature-title {
                font-family: 'Orbitron', monospace;
                font-size: clamp(2rem, 4vw, 3rem);
                font-weight: 900;
                margin-bottom: 20px;
                text-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
            }

            .feature-description {
                font-size: clamp(1rem, 2vw, 1.2rem);
                line-height: 1.4;
                font-weight: 400;
            }

   /* Footer */
.footer {
    padding: 150px 20px 30px;
    background: linear-gradient(180deg, rgba(10, 10, 10, 0.9), rgba(5, 5, 5, 1));
    border-top: 1px solid rgba(0, 255, 255, 0.3);
}

.footer-container {
    max-width: 1400px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 40px;
    margin-bottom: 60px;
}

/* Responsive Design */
@media (max-width: 768px) {
    .footer {
        padding: 60px 20px 30px;
    }

    .footer-container {
        grid-template-columns: 1fr;
        margin-bottom: 30px;
    }
}

            .footer-section h3 {
                font-family: 'Orbitron', monospace;
                font-size: 20px;
                font-weight: 700;
                margin-bottom: 20px;
                color: var(--primary-cyan);
            }

            .footer-section p,
            .footer-section a {
                color: var(--new-color);
                text-decoration: none;
                line-height: 1.8;
                font-size: 14px;
                transition: color 0.3s ease;
            }

            .footer-section a:hover {
                color: var(--primary-cyan);
            }

            .footer-bottom {
                text-align: center;
                padding-top: 30px;
                border-top: 1px solid rgba(0, 255, 255, 0.2);
                color: var(--text-dim);
                font-size: 12px;
            }

            /* Responsive Design */
            @media (max-width: 768px) {
             


                .hero {
                    padding-top: 60px;
                }

                .hero-container {
                    grid-template-columns: 1fr;
                    gap: 30px;
                    text-align: center;
                    padding: 0 15px;
                }

                .hero-visual {
                    height: 300px;
                }

                .floating-box {
                    width: 150px;
                    height: 150px;
                }

                .floating-box::before {
                    font-size: 40px;
                }

                .marquee-item {
                    padding: 0 20px;
                    font-size: 14px;
                }

                .reviews-container {
                    padding: 10px 0;
                }

                .review-card {
                    min-width: 240px;
                    padding: 20px;
                }

                .steps-container {
                    grid-template-columns: 1fr;
                    gap: 30px;
                }

                .lockers-grid {
                    grid-template-columns: 1fr;
                    gap: 20px;
                }

                .app-container {
                    grid-template-columns: 1fr;
                    gap: 30px;
                    text-align: center;
                }

                .sticky-cards {
                    gap: 20vh;
                    padding-bottom: 20vh;
                }

                .feature-card {
                    padding: 40px 15px;
                    height: auto;
                    min-height: 80vh;
                }
            }

            /* Custom scrollbar */
            ::-webkit-scrollbar {
                width: 8px;
            }

            ::-webkit-scrollbar-track {
                background: var(--darker-bg);
            }

            ::-webkit-scrollbar-thumb {
                background: linear-gradient(180deg, var(--primary-cyan), var(--primary-purple));
                border-radius: 4px;
            }

            ::-webkit-scrollbar-thumb:hover {
                background: linear-gradient(180deg, var(--primary-purple), var(--primary-pink));
            }
          `
        }}
      />
      <div className="bg-animation" />
     <Navbar/>

    
      {/* Hero Section */}
      <section className="hero" id="home">
  <div className="background-silk-wrapper">
    <Silk
      speed={5}
      scale={1}
      color="#7000CC"
      noiseIntensity={1.5}
      rotation={0}
      className="background-silk"
    />
  </div>

  <div className="hero-container">
    <div className="hero-content">
      <h1 className="hero-title">BlocBox</h1>
      <p className="hero-subtitle">
        Shop from <span className="hero-highlight">ANY</span> Malaysian Online
        Store. We'll handle the rest with our A-grade delivery system.
      </p>
      <div className="cta-button">RESERVE YOUR LOCKER</div>
    </div>
    <div className="hero-visual">
      <div className="floating-box" />
    </div>
  </div>
</section>

      {/* Marquee */}
      <section className="marquee-section">
        <div className="marquee">
          <div className="marquee-item">LAZADA & SHOPEE COMPATIBLE</div>
          <div className="marquee-item">SINGAPORE DELIVERY</div>
          <div className="marquee-item">MULTIPLE LOCKER SIZES</div>
          <div className="marquee-item">LAZADA & SHOPEE COMPATIBLE</div>
          <div className="marquee-item">SINGAPORE DELIVERY</div>
          <div className="marquee-item">MULTIPLE LOCKER SIZES</div>
          <div className="marquee-item">LAZADA & SHOPEE COMPATIBLE</div>
          <div className="marquee-item">SINGAPORE DELIVERY</div>
          <div className="marquee-item">MULTIPLE LOCKER SIZES</div>
          <div className="marquee-item">LAZADA & SHOPEE COMPATIBLE</div>
          <div className="marquee-item">SINGAPORE DELIVERY</div>
          <div className="marquee-item">MULTIPLE LOCKER SIZES</div>
          <div className="marquee-item">LAZADA & SHOPEE COMPATIBLE</div>
          <div className="marquee-item">SINGAPORE DELIVERY</div>
          <div className="marquee-item">MULTIPLE LOCKER SIZES</div>
          <div className="marquee-item">LAZADA & SHOPEE COMPATIBLE</div>
          <div className="marquee-item">SINGAPORE DELIVERY</div>
          <div className="marquee-item">MULTIPLE LOCKER SIZES</div>
          <div className="marquee-item">LAZADA & SHOPEE COMPATIBLE</div>
          <div className="marquee-item">SINGAPORE DELIVERY</div>
          <div className="marquee-item">MULTIPLE LOCKER SIZES</div>
          <div className="marquee-item">LAZADA & SHOPEE COMPATIBLE</div>
          <div className="marquee-item">SINGAPORE DELIVERY</div>
          <div className="marquee-item">MULTIPLE LOCKER SIZES</div>
          <div className="marquee-item">LAZADA & SHOPEE COMPATIBLE</div>
          <div className="marquee-item">SINGAPORE DELIVERY</div>
          <div className="marquee-item">MULTIPLE LOCKER SIZES</div>
          <div className="marquee-item">LAZADA & SHOPEE COMPATIBLE</div>
          <div className="marquee-item">SINGAPORE DELIVERY</div>
          <div className="marquee-item">MULTIPLE LOCKER SIZES</div>
        </div>
      </section>

      {!bannerLoading && bannerData && bannerData.is_active && (
  <section className="admin-banner-section" style={{
    background: bannerData.banner_image_url 
      ? 'transparent' 
      : 'linear-gradient(135deg, rgba(16, 185, 129, 0.12), rgba(5, 150, 105, 0.12))'
  }}>
    <div className="admin-banner-container">
      {bannerData.banner_image_url && (
        <img 
          src={bannerData.banner_image_url} 
          alt="Banner background" 
          className="admin-banner-background"
        />
      )}
      <p className="admin-banner-text">{bannerData.banner_text}</p>
    </div>
  </section>
)}

      <section className="disclaimer-section" id="disclaimer">
  <div className="disclaimer-container">
    <h2 className="section-title">IMPORTANT NOTICE</h2>
    <p className="disclaimer-text">
      Do not order dutiable or prohibited goods via our Cross-Border Service. Ensure your items comply with Singapore’s import regulations to avoid issues. 
      <a 
        href="https://www.ica.gov.sg/enter-transit-depart/entering-singapore/what-you-can-bring" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="disclaimer-link"
      >
        View Prohibited Items
      </a> | 
      <a 
        href="https://www.customs.gov.sg/businesses/valuation-duties-taxes-and-fees/duties-and-dutiable-goods/" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="disclaimer-link"
      >
        View Dutiable Items
      </a>
    </p>
  </div>
</section>
      

      <section className="how-it-works" id="how-it-works">
        <h2 className="section-title">HOW IT WORKS</h2>
        <div className="steps-container">
          <div className="step-card">
            <div className="step-number">01</div>
            <h3 className="step-title">Order from Any Malaysian Store</h3>
            <p className="step-description">
              Shop like a local. Just use our JB locker address as your delivery
              address at checkout.
            </p>
          </div>
          <div className="step-card">
            <div className="step-number">02</div>
            <h3 className="step-title">We Store It for You</h3>
            <p className="step-description">
              Your parcel is received, stored securely in a locker, and you get
              notified with the locker pin and photo.
            </p>
          </div>
          <div className="step-card">
            <div className="step-number">03</div>
            <h3 className="step-title">Collect or Deliver to SG</h3>
            <p className="step-description">
              Pick it up from JB or request delivery to any Singapore address at
              checkout.
            </p>
          </div>
        </div>
      </section>
      {/* Locker Sizes Section */}
      <section className="locker-sizes" id="lockers">
        <h2 className="section-title">4 DIFFERENT LOCKER SIZES</h2>
        <p
          style={{
            textAlign: "center",
            fontSize: 18,
            color: "var(--text-dim)",
            marginBottom: 30
          }}
        >
          Choose the right size for your parcel. We've got lockers for everything
          from small gadgets to household appliances.
        </p>
        <div className="lockers-grid">
          <div className="locker-card">
            <div className="locker-icon"></div>
            <h3 className="locker-name">MINI LOCKER</h3>
            <p className="locker-description">
              Perfect for small items like phone accessories, jewelry, or compact
              electronics
            </p>
          </div>
          <div className="locker-card">
            <div className="locker-icon"></div>
            <h3 className="locker-name">SMALL LOCKER</h3>
            <p className="locker-description">
              Ideal for compact parcels, books, clothing accessories, or beauty
              products
            </p>
          </div>
          <div className="locker-card">
            <div className="locker-icon"></div>
            <h3 className="locker-name">MEDIUM LOCKER</h3>
            <p className="locker-description">
              Great for clothes, shoes, multiple small items, or medium-sized
              electronics
            </p>
          </div>
          <div className="locker-card">
            <div className="locker-icon"></div>
            <h3 className="locker-name">MAXI LOCKER</h3>
            <p className="locker-description">
              For big boxes, household appliances, bulk orders, or large electronics
            </p>
          </div>
        </div>
      </section>
      {/* Pricing Section */}
      <section className="pricing-section" id="pricing">
        <div className="pricing-container">
          <div className="pricing-content">
            <h2 className="pricing-title">AFFORDABLE & SAFE STORAGE</h2>
            <ul className="pricing-features">
              <li>24/7 Locker Access</li>
              <li>24/7 customer support</li>
              <li>Secure parcel storage</li>
            </ul>
            <div className="price-display">FROM RM 14.90</div>
            <div className="price-note">per locker</div>
            <div className="cta-button">GET STARTED NOW</div>
          </div>
        </div>
      </section>

      <div style={{
  height: '200vh',
  width: '100vw',

  position: 'relative',
  alignContent: 'center',
  justifyContent: 'center',
  alignItems: 'center'
}}>
       <h2 className="section-title">WHY CHOOSE US?</h2>
       <p
          style={{
            textAlign: "center",
            fontSize: 18,
            color: "var(--text-dim)",
            marginBottom: 30
          }}
        >
          Touch and Drag to find out
        </p>
  <div style={{
    height: '60vh',
    backgroundColor: 'red',                    // Ensure nothing is clipped
  }}>
    <InfiniteMenu items={items} />
  </div>
</div>
      {/* App Section */}
      <section className="app-section" id="app">
        <div className="app-container">
          <div className="app-content">
            <h2>GET THE LOCKER APP</h2>
            <p>
              Track parcels, get locker PINs, and request Singapore delivery with
              one tap.
            </p>
            <div className="cta-button">DOWNLOAD APP</div>
          </div>
        </div>
      </section>
      {/* Sticky Feature Cards */}
      <section className="features-section">
        <div className="sticky-cards">
          <div className="feature-card">
            <div className="feature-content">
              <h3 className="feature-title">CROSS-BORDER DELIVERY</h3>
              <p className="feature-description">
                Order items from any Malaysian online store and have them delivered
                directly to our secure lockers located in Johor Bahru (JB). We
                provide you with a valid Malaysian delivery address to complete your
                checkout smoothly.
              </p>
            </div>
          </div>
          <div className="feature-card">
            <div className="feature-content">
              <h3 className="feature-title">SECURE LOCKERS IN JB</h3>
              <p className="feature-description">
                Our lockers come in FOUR sizes — Mini, Small, Medium, and Large — to
                accommodate all kinds of packages. Each locker is located in
                strategic, easily accessible JB spots for convenient pickup or
                onward delivery.
              </p>
            </div>
          </div>
          <div className="feature-card">
            <div className="feature-content">
              <h3 className="feature-title">PICKUP OR SG DELIVERY</h3>
              <p className="feature-description">
                Once your item arrives in the locker, you'll get a secure code to
                open it. You can either come to JB and collect the item yourself, or
                request a last-mile delivery from JB to your address in Singapore.
              </p>
            </div>
          </div>
          <div className="feature-card">
            <div className="feature-content">
              <h3 className="feature-title">SAVE ON MALAYSIAN DEALS</h3>
              <p className="feature-description">
                Enjoy cheaper prices by shopping from Malaysian e-commerce
                platforms. Our service makes it possible to access Malaysia-only
                deals, even without a Malaysian address, saving you money and
                hassle.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3>BlocBox</h3>
            <p>
              Your easy gateway to Malaysian online shopping. Secure, fast, and
              reliable cross-border delivery service.
            </p>
          </div>
          <div className="footer-section">
            <h3>SERVICES</h3>
            <p><div>Locker Rental</div></p>
            <p><div>Cross Border Delivery</div></p>
          </div>
          <div className="footer-section">
            <h3>SUPPORT</h3>
            <p><Link to="/aboutus">FAQ</Link></p>
            <p><Link to="/contactus">Contact Us</Link></p>
            <p>
              <a 
                href="https://www.ica.gov.sg/enter-transit-depart/entering-singapore/what-you-can-bring" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                Prohibited Item List
              </a>
            </p>

          </div>
          <div className="footer-section">
            <h3>LEGAL</h3>
            <p style={{cursor: 'pointer'}}><div onClick={() => navigate('/termspage')}>Terms of Service</div></p>
            <p  style={{cursor: 'pointer'}}><div onClick={() => navigate('/privacypage')}>Privacy Policy</div></p>
           
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            © 2025 BlocBox. All rights reserved. | Bridging Singapore &
            Malaysia through A-grade logistics.
          </p>
        </div>
      </footer>
    </>
    
  );
}

export default HomePage;